import { render, staticRenderFns } from "./PedidoCard.vue?vue&type=template&id=d9ee36b8"
import script from "./PedidoCard.vue?vue&type=script&lang=js"
export * from "./PedidoCard.vue?vue&type=script&lang=js"
import style0 from "./PedidoCard.vue?vue&type=style&index=0&id=d9ee36b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports